import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from './theme';

// SAMKLR icon mark — two stroke paths forming an architectural R/square.
// Navy primary outline + copper accent on the upper-right corner.
// Pulled directly from the Stitch design output (clean SVG, no raster).
export function IconMark({ size = 32, primary = colors.primary, accent = colors.accent }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="SAMKLR"
      role="img"
    >
      <path
        d="M60 140V60H100L140 100V140H100L60 100"
        stroke={primary}
        strokeWidth="14"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="square"
      />
      <path
        d="M100 60L140 60V100"
        stroke={accent}
        strokeWidth="14"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="square"
      />
    </svg>
  );
}

// Custom wordmark — Archivo Narrow 700, condensed, mild tracking. Avoids the
// generic-Helvetica default Stitch kept producing. Scales down a notch on
// narrow viewports so the topbar lockup doesn't crowd out the rest of the
// nav on phones.
const WordmarkSpan = styled.span`
  font-family: ${fonts.display};
  font-weight: 700;
  font-size: ${props => props.$size || 22}px;
  letter-spacing: 0.08em;
  line-height: 1;
  color: ${props => props.$color || colors.primary};
  font-feature-settings: 'ss01' on, 'ss02' on;

  @media (max-width: 600px) {
    font-size: ${props => Math.max(14, (props.$size || 22) - 6)}px;
    letter-spacing: 0.06em;
  }
`;

export function Wordmark({ size = 22, color }) {
  return <WordmarkSpan $size={size} $color={color}>SAMKLR</WordmarkSpan>;
}

// Lockup: icon + wordmark side by side. Default tight horizontal.
const LockupWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => Math.max(8, props.$gap || 10)}px;
`;

export function Lockup({ iconSize = 28, wordSize, color, gap = 10 }) {
  const w = wordSize || Math.round(iconSize * 0.78);
  return (
    <LockupWrap $gap={gap}>
      <IconMark size={iconSize} primary={color} accent={colors.accent} />
      <Wordmark size={w} color={color} />
    </LockupWrap>
  );
}

export default Lockup;
